import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import type { ReactElement } from 'react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export const ModeToggle = (): ReactElement => {
  const { setTheme } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="
            rounded-full bg-gray-50
            hover:bg-gray-100
            dark:bg-gray-800
            dark:hover:bg-gray-700
          "
        >
          <Sun
            className="
              h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all
              dark:scale-0 dark:-rotate-90
            "
          />
          <Moon
            className="
              absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all
              dark:scale-100 dark:rotate-0
            "
          />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl">
        <DropdownMenuItem
          className="rounded-lg"
          onClick={() => {
            setTheme('light')
          }}
        >
          Light
        </DropdownMenuItem>
        <DropdownMenuItem
          className="rounded-lg"
          onClick={() => {
            setTheme('dark')
          }}
        >
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem
          className="rounded-lg"
          onClick={() => {
            setTheme('system')
          }}
        >
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
